import React, { useEffect, useState } from 'react'
import { Formik, Field, Form as FormikForm } from 'formik';
import { Button, Container, Dimmer, Form, Header, Loader, Modal } from 'semantic-ui-react'
import { FormikDateComponent, FormikInputComponent } from '../../../utilities/formUtils'
import { useDispatch, useSelector } from 'react-redux';
import { fetchedPullOldSyncStatus, pullOldSyncStatus } from '../data/actions';
import * as select from '../data/selectors'
import { oldsync, oldSyncSchema } from '../data/model';
import { toast } from 'react-toastify';


const OldSyncPullForm = (props) => {


    const initialValues = useSelector(state => select.getOldSyncData(state, props))
    const oldSyncStatus = useSelector(state => select.getOldSyncStatus(state, props))
    const dispatch = useDispatch()

    const [loaderActive, setLoaderActive] = useState(false)

    const downloadFiles = (values, resetForm) => {
        dispatch(pullOldSyncStatus(values))
        setLoaderActive(true)
        setTimeout(() => {
            resetForm()
        }, 1000)

    }

    // console.log('oldsyncStatus====type', typeof (oldSyncStatus))
    useEffect(() => {
        if (oldSyncStatus && oldSyncStatus !== "") {
            setLoaderActive(false)
            setTimeout(() => {
                toast.success(oldSyncStatus)
                dispatch(fetchedPullOldSyncStatus(""))
            }, 300)
        }

    }, [oldSyncStatus])

    return (
        <>
            {loaderActive &&
                <Dimmer active>
                    <Loader indeterminate>Old Files Syncing</Loader>
                </Dimmer>
            }
            <Header as='h1'>Old Sync Status Transfer</Header>
            <br></br>
            <Formik id="download"
                initialValues={initialValues}
                validationSchema={oldSyncSchema}
                onSubmit={(values, { resetForm }) => { downloadFiles(values, resetForm) }}
                render={({ handleSubmit, errors, onChange, values, handleChange }) => (
                    <Form as={FormikForm} size="small" width={5} onSubmit={handleSubmit}>
                        <Form.Group widths={5}>
                            <Field name="dtValue" component={FormikDateComponent} isTxn='false' label="Sync Date" placeholder='Sync Date' />
                        </Form.Group>
                        <br />
                        <Button type="submit" color='green' size='medium'>Sync</Button>
                    </Form>
                )}
            />
        </>
    )
}

export default OldSyncPullForm